import React, { useEffect, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import SubCategoryComp from "./SubCategoryComp";
import CategoryModal from "../../../Components/Modals/MenuCategoryModal/CategoryModal";
import { allRolePermission } from "../../../temp";

function Subcategory({meta}) {
  const [changeStore, setChangeStore] = useState(false);
  const [accessSubCategory, setAccessSubCategory] = useState({
    read: true,
    add: true,
    update: true,
    delete: true,
  });

  const permission = allRolePermission;

  // useEffect(() => {
  //   if (permission) {
  //     let accessRights = {
  //       read: false,
  //       add: false,
  //       update: false,
  //       delete: false,
  //     };

  //     permission.forEach((p) => {
  //       if (p?.component?.name === "menu_subcategory") {
  //         accessRights = {
  //           read: p.permissions?.some((perm) => perm.permissionName === "Read"),
  //           add: p.permissions?.some(
  //             (perm) => perm.permissionName === "Create"
  //           ),
  //           update: p.permissions?.some(
  //             (perm) => perm.permissionName === "Update"
  //           ),
  //           delete: p.permissions?.some(
  //             (perm) => perm.permissionName === "Delete"
  //           ),
  //         };
  //       }
  //     });

  //     setAccessSubCategory(accessRights);
  //   }
  // }, [permission]);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      // copyfilter[]

      if (data.filter) {
        // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
        // console.log("Object.keys[copyfilter]",Object.keys(data.filter))

        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const getVenderItem = (venderId, data) => {
    handlePagination(venderId);
  };

  return (
    <>
      <CommonLayout />
      <div className={`flex w-full justify-between flex-wrap p-[2rem]`}>
        <div>
          <p className={`text-[1.3rem] text-[--text-color3] capitalize`}>
            {"All Stores"}
            <span className={`text-[0.9rem] text-[--color-tbl-data] ml-3`}>
              {/* {venderName && `(${venderName?.address})`} */}
            </span>
          </p>
          {/* <div className={`inline-block h-[2.5rem] flex items-center border border-[#e34e4e] rounded-[15px] px-[5px] py-[10px] cursor-pointer`}>
              <input
                type="text"
                style={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                }}
                value={search}
                onChange={debouncedSearch}
                placeholder="Search"
              />
              <CiSearch size={"1.1rem"} />
            </div> */}
        </div>

        <div className="flex gap-2">
          {/* <p className={`btn-border h-[2.5rem]`} onClick={() => addSubCategory()}>
              Add Subcategory
            </p> */}
          {/* 
          <p
            className={`btn-border h-[2.5rem]`}
            onClick={() => setChangeStore(true)}
          >
            Change Store
          </p> */}
        </div>
      </div>
      <SubCategoryComp
        pagination={pagination}
        handlePagination={handlePagination}
        accessSubCategory={accessSubCategory}
      />
      {changeStore && (
        <CategoryModal
          setChangeStore={setChangeStore}
          getAllVendorCategory={getVenderItem}
        />
      )}
    </>
  );
}

export default Subcategory;
